module.exports = __webpack_public_path__ + "assets/57f98e445b60aafc72020ff7e01967b2.mp3";